"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractConfig = extractConfig;
exports.useStylesheet = exports["default"] = exports.alignmentStyle = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _CopyButton = _interopRequireDefault(require("../../../button/CopyButton"));

var _styling = require("../../../../toolkit/styling");

var _providers = require("../../../../toolkit/providers");

var _device = require("../../../../toolkit/device");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable-next-line
function extractConfig(props, config, cell) {
  if (props[config] === null) {
    return null;
  }

  if (typeof props[config] === "function") {
    return props[config](cell);
  }

  return props[config];
}

var alignmentStyle = function alignmentStyle(align) {
  switch (align) {
    case "left":
      return {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center"
      };

    case "right":
      return {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "center"
      };

    case "stretch":
      return {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "center"
      };

    default:
      return {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      };
  }
};

exports.alignmentStyle = alignmentStyle;
var ColumnContent = (0, _mobxReact.observer)(function (props) {
  var row = props.row,
      value = props.value,
      index = props.index,
      sectionKey = props.section.config.sectionKey,
      canCopyText = props.canCopyText,
      noDataMessage = props.noDataMessage,
      handleEmptyRow = props.handleEmptyRow;
  var styles = useStylesheet(props);

  if (typeof props.children === "function") {
    /* eslint-disable react/destructuring-assignment */
    if (value != null || handleEmptyRow) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children({
        row: row,
        value: value,
        index: index,
        section: sectionKey
      }));
    }
  }

  if (value == null) {
    if (typeof noDataMessage === "function") {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, noDataMessage());
    }

    return noDataMessage != null ? /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _styling.css)(styles.text, styles.noData)
    }, noDataMessage) : /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _styling.css)(styles.text, styles.noData)
    }, "No Data");
  }

  var text = /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.text)
  }, value);

  if (canCopyText) {
    return /*#__PURE__*/_react["default"].createElement(_CopyButton["default"], {
      text: value,
      copyOnBodyClick: true
    }, text);
  }

  return text;
});
var BasicColumn = (0, _mobxReact.observer)(function (props) {
  var internalProps = props;
  var styles = useStylesheet(internalProps);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, props.className)
  }, /*#__PURE__*/_react["default"].createElement(ColumnContent, internalProps));
});
var _default = BasicColumn;
exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref) {
  var multiline = _ref.multiline,
      align = _ref.align,
      width = _ref.width;

  var _useDeviceStore = (0, _device.useDeviceStore)(),
      isSmallScreen = _useDeviceStore.isSmallScreen;

  var _useTheming = (0, _providers.useTheming)(),
      _useTheming$theme = _useTheming.theme,
      textBlack = _useTheming$theme.textBlack,
      textLight = _useTheming$theme.textLight;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: _objectSpread({
        color: textBlack
      }, alignmentStyle(align || "left")),
      text: {
        maxWidth: width || "100%",
        // don't force the parent <td/> to be larger than the assigned width
        textOverflow: multiline ? undefined : "ellipsis",
        whiteSpace: multiline ? "normal" : "nowrap",
        wordWrap: multiline ? "break-word" : undefined,
        overflow: multiline ? undefined : "hidden",
        fontSize: isSmallScreen ? 18 : 15
      },
      noData: {
        color: textLight
      }
    });
  }, [align, multiline, width, textBlack, textLight, isSmallScreen]);
};

exports.useStylesheet = useStylesheet;